export default function YandexLogo({ color = "#ffffff", size = 100 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 55C0 85.3757 24.6243 110 55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55Z" fill="#F8604A" />
            <path d="M63.1099 30.8021H57.5439C48.0015 30.8021 43.2306 35.5732 43.2306 42.7299C43.2306 50.6818 46.4113 54.6577 53.568 59.4287L59.134 63.4045L43.2306 88.0553H30.5076L45.6161 65.7903C36.8691 59.4287 32.098 53.8622 32.098 43.525C32.098 30.8021 40.845 22.0551 57.5439 22.0551H74.2424V88.0553H63.1099V30.8021Z" fill={color} />
        </svg>
    )
}
